import React, { Component } from "react";
import Site, { withSite, SiteModifier_ } from "../utils/Site";
import { TweenLite, ScrollTo, Linear, Expo } from "gsap";
import { compose, withProps } from "recompose";

import { Link } from "react-router-dom";

import Base from "../components/BaseComponent";
import Intro from "../components/Intro";
import Navigation from "../components/Navigation";
import Item from "../components/Item";
import Content from "../components/Content";
import Grid from "../components/Grid";
import Media from "../components/Media";
import Newsletter from "../components/Newsletter";
import Button from "../components/Button";
import Image from "../components/Image";
import FadeIn from "../components/FadeIn";
import GoogleMap from "../components/Map";
import MapFilters from "../components/MapFilters";
import TouchScroller from "../components/TouchScroller";
import TouchFilters from "../components/TouchFilters";
import Icon from "../components/Icon";
import LocationAd from "../components/LocationAd";
import ScrollTop from '../components/ScrollTo'


import Asset from "../models/Asset";
import Entry from "../models/Entry";

import withData from "../utils/withData";

let lastMode = 0;

class Map extends Component {
	constructor(props) {
		super(props);

		let mode = 'map';

		if(this.props.entry.defaultView)
		{

			mode = this.props.entry.defaultView.value
		}

		if(window.location.hash){

			if(window.location.hash == '#list') mode = 'list';

		}else{

			if(lastMode) mode = lastMode;


		}

		lastMode = mode;

		this.state = {
			mode: mode,
			cols: 4,
			maxCols: 4,
			isUpdating: false,
			activeMarker: null,
			activeCenter: null
		};

		this.props.site.deModify('map-view')
		this.props.site.deModify('list-view')
		this.props.site.modify(mode + '-view')

	}

	componentWillReceiveProps(nextProps)
	{
		//console.log(nextProps.entry)
		this.setState(
		{
			cols: nextProps.entry.columns
		})
	}

	componentDidUpdate()
	{
		//console.log('update!')
	}

	componentDidMount() {
		//this.setState({ cols: 1 });
		this.setState({ maxCols: this.props.entry.columns || 4 });

		this.isTouch =
			"ontouchstart" in document.documentElement ? true : false;

		/*this.activeMarker = null;*/

		let links = document.querySelectorAll(".Filters .Navigation a");
		let _this = this;

		//setTimeout(function()
		//{
		for (var i = 0; i < links.length; i++) {
			let offset = _this.offset(links[i]);
			let linkOffset = offset.left + offset.width / 2;
			//console.log(offset.width);
			links[i].setAttribute("data-left", linkOffset);
			links[i].setAttribute("data-width", offset.width);

			if (i == 0) _this.firstLink = offset.width / 2;
			if (i == links.length - 1) _this.lastLink = offset.width / 2;
		}

		//_this.animateFilters();
		//},200)

		//this.itemOver(this.refs.firstItem.getAttribute('data-item'));
	}

	componentWillUnmount() {
		this.props.site.deModify('map-view')
		this.props.site.deModify('list-view')
	}

	filter = item => {
		let entryCat = typeof this.props.entry.locationCategory == 'string' ? this.props.entry.locationCategory : this.props.entry.locationCategory[0]
		if(typeof item.locationCategory == 'string')
		{
			return (
				item.locationCategory == entryCat ||
				entryCat == null
			)
		} else {
			return (
				item.locationCategory.indexOf(entryCat) > -1 ||
				entryCat == null
			)
		}
	};

	switchView = () => {
		let mode = this.state.mode == "map" ? "list" : "map";
		let cols = this.state.mode == "map" ? this.state.maxCols : 1;

		this.props.site.deModify(this.state.mode + '-view')
		this.props.site.modify(mode + '-view')

		this.setState({ mode: mode });
		lastMode = mode;
		this.setCols(cols);

		//document.querySelectorAll('.Site')[0].scrollTop = 0;
	};

	setCols = cols => {
		this.setState({ cols: cols });
	};

	itemOver = item => {
		//console.log('itemOver',item)
		if (!this.isTouch) this.setState({ activeMarker: item });
	};
	itemOut = item => {
		if (!this.isTouch) this.setState({ activeMarker: null });
	};

	animateFilters = () => {
		let _this = this;
		let locations = this.refs.locationScroller;

		locations.scrollTop = 0;

		setTimeout(function() {
			let clicked = document.querySelectorAll(
				".Filters .Navigation a.is-active"
			)[0];
			let offset = _this.offset(clicked);
			let clickedOffset = clicked.getAttribute("data-left");

			let filters = document.getElementById("filters");
			let scrollPos = clickedOffset - window.innerWidth / 2;

			filters.style.left = -scrollPos + "px";

			//let t = TweenLite.to(filters,2.5,{left:{ x: scrollPos }});

			//console.log(clickedOffset - filters.scrollLeft, filters.scrollLeft)
		}, 100);
	};

	offset = el => {
		let rect = el.getBoundingClientRect();
		return { top: rect.top, left: rect.left, width: rect.width };
	};

	onInit = scroller => {
		const { tl, length } = scroller;
		const _this = this;

		setTimeout(function() {
			//_this.refs.content.style.marginLeft = -(_this.firstLink) + 'px'

			let scrollDist =
				_this.refs.content.offsetWidth -
				_this.lastLink -
				_this.firstLink -
				window.innerWidth;
			let totalLength = scrollDist + window.innerWidth;

			let introTime = window.innerWidth / totalLength;
			let storyTime = 50;

			scroller.setLength(scrollDist);

			/*tl.to(_this.refs.blackLogo, introTime, {height:0,ease:Linear.easeNone,onUpdate:function(){


			}});*/

			tl.to(_this.refs.content, storyTime, {
				x: -scrollDist,
				ease: Linear.easeNone,
				onUpdateParams: ["{self}"],
				onCompleteParams: ["{self}"],
				onUpdate: function(tween) {
					let scrollPos = Math.abs(tween.target._gsTransform.x);
					_this.setState({ scroll: scrollPos });
				}
			});
		}, 300);

		this.scroller = scroller;
		this.hasScroller = 1;
	};

	initTouchFilters = scroller => {
		let items = document.querySelectorAll(".Template-categories--touch .Navigation a");
		let itemWidth = items[0].offsetWidth;
		let itemHeight = 40;//document.querySelectorAll(".Filters .Navigation li")[0].offsetHeight;
		scroller.setupScroll(items, null, itemHeight, false);
		this.filterScroller = scroller
	};

	filterSnap = el => {
		if(!this.isTouch) return
			//console.log(el)
		el.click()
		this.resetTouchScroller();
	};

	resetTouchScroller = () => {
		if(!this.isTouch) return
		//console.log('reset')
		this.touchScroller.resetX();
	}

	initTouchScroller = scroller => {
		this.touchScroller = scroller;
		let items = document.querySelectorAll(".Grid-item");
		let itemWidth = items[0].offsetWidth;
		let itemHeight = items[0].offsetHeight;
		scroller.setupScroll(items, itemWidth * items.length, itemHeight, true);
	};

	touchSnap = el => {
		if(!this.isTouch || !el) return
		let item = this.getDataFromId(el.getAttribute("data-id"));



		this.setState(
			{
				activeMarker: item,
				activeCenter: {lat: parseFloat(item.longitude), lng: parseFloat(item.latitude)}
			}
		);
	};

	getDataFromId = id => {
		for (var i = 0; i < this.filteredItems.length; i++) {
			if (this.filteredItems[i].id == id) return this.filteredItems[i];
		}
	};

	getSummary = () => {
		if(this.props.entry.summary)
		{
			return (
				<div class="Template-locations-head">
									<Content html={this.props.entry.summary}/>
								</div>);
		} else {
			return null
		}
	}

	/*

		RENDER

	*/

	render() {
		const { entry } = this.props;
		//console.log('map render')
		//console.log('entry',entry);

		let compare =
			entry.locationCategory == "live" ? (
				<FadeIn>
				<Content modifier={"yellow"}>
					<Link to={"/map/live/compare"}>Compare Amenities</Link>
				</Content>
				</FadeIn>
			) : null;

		let mode = "map";
		let cols = this.props.entry.columns.value || 4;

		return (
			<FadeIn><ScrollTop pos={0} />
				<div className="Template  Template--grid">
					<div className="Template-categories">
						<MapFilters className="Filters" onInit={this.onInit}>
							<div
								className="Filters-scroller"
								id="filters"
								ref="content"
							>
								<Entry
									id={this.props.data.map}
									results={items => (
										<div>
											<Navigation
												modifiers={["filters"]}
												items={items}
												hash={this.state.mode}
											/>
										</div>
									)}
								/>
							</div>
						</MapFilters>

						<div className="Template-compareLink">{compare}</div>
						<div
							className={
								"Template-switcher Template-switcher--" +
								this.state.mode
							}
							onClick={this.switchView}
						/>
					</div>

					<div className="Template-categories Template-categories--touch">
						<TouchFilters
							modifier="filters"
							onInit={this.initTouchFilters}
							align="center"
							offset={window.innerWidth/2}
							itemSnap={this.filterSnap}
							activeEntry={entry}
							onEntryChange={this.resetTouchScroller}
						>
							<Entry
								id={this.props.data.map}
								results={items => (
									<div>
										<Navigation
											modifiers={["filters"]}
											items={items}
										/>
									</div>
								)}
							/>
						</TouchFilters>

						<div className="Template-compareLink">{compare}</div>
						<div
							className={
								"Template-switcher Template-switcher--" +
								this.state.mode
							}
							onClick={this.switchView}
						/>
					</div>

					<div
						className={
							"Template-body Template-body--" + this.state.mode
						}
						ref="body"
					>
						<div className="Template-locations Template-locations--map">
							<div
								className="Template-scroller"
								id="locationScroller"
								ref="locationScroller"
							>
								<TouchScroller
									onInit={this.initTouchScroller}
									itemSnap={this.touchSnap}
									modifier="items"
									align="left"
									offset={0}
								>
									<Grid modifiers={[this.state.cols]}>
										<Entry
											id={this.props.data.locations}
											filter={this.filter}
											results={items => {
												this.filteredItems = items;

												return items.map(item => {
													return (
														<div
															className={
																"Grid-item"
															}
															data-id={item.id}
														>
															<Item
																modifiers={[
																	"grid",
																	"map"
																]}
															>
																<Link
																	to={
																		item.uri
																	}
																>
																	<div
																		className="Item-media"
																		onMouseOver={() => {
																			this.itemOver(
																				item
																			);
																		}}
																		onMouseOut={() => {
																			this.itemOut(
																				item
																			);
																		}}
																	>
																		<Media
																			id={
																				item
																					.image[0]
																			}
																		/>
																	</div>

																	<div className="Item-head">
																		<div className="Item-title">
																			<Content
																				modifier={
																					"yellow"
																				}
																				html={'<h5>'+item.title+'</h5>'}
																			>
																			</Content>
																		</div>
																		<div className="Item-subTitle">
																			<Content
																			>
																				<h6
																				>
																					{
																						item.locationType
																					}
																				</h6>
																			</Content>
																		</div>
																	</div>
																</Link>
															</Item>
														</div>
													);
												});
											}}
										/>
									</Grid>
								</TouchScroller>
							</div>
						</div>

						<div className="Template-locations Template-locations--list">

								{this.getSummary()}

								<Grid modifiers={[this.state.cols]}>

										<Entry
											id={this.props.data.locations}
											filter={this.filter}
											results={items => {
												this.filteredItems = items;

												return items.map((item,ix) => {

													let ad = null;
													let blank = null;


													// 'All ' tall ad (needs ad and blank in index + 3)
													if(this.props.entry.locationCategory == null){
														let adPos = 10;

														if(ix == adPos){

															//ad = <div className="Grid-item Grid-item--ad"><LocationAd type={'tall'} /></div>

														}

														if(ix == (adPos+3)){

															//blank = <div className="Grid-item Grid-item--blank">BLANK</div>

														}
													}

													// 'Eat' has small ad

													if(this.props.entry.locationCategory == 'eat'){

														let adPos = 8;

														if(ix == adPos){

															//ad = <div className="Grid-item Grid-item--ad"><LocationAd type={'small'} /></div>

														}

													}

													return ([ad,blank,
														<div
															className={
																"Grid-item"
															}
															data-id={item.id}
														>
															<Item
																modifiers={[
																	"grid"
																]}
															>
																<Link
																	to={
																		item.uri
																	}
																>
																	<div
																		className="Item-media"
																		onMouseOver={() => {
																			this.itemOver(
																				item
																			);
																		}}
																		onMouseOut={() => {
																			this.itemOut(
																				item
																			);
																		}}
																	>
																		<Media
																			id={
																				item
																					.image[0]
																			}
																		/>
																	</div>

																	<div className="Item-head">
																		<div className="Item-title">
																			<Content
																				modifier={
																					"yellow"
																				} html={'<h5>'+item.title+'</h5>'}
																			>
																				
																			</Content>
																		</div>
																		<div className="Item-subTitle">
																			<Content
																			>
																				<h6
																				>
																					{
																						item.locationType
																					}
																				</h6>
																			</Content>
																		</div>
																	</div>
																</Link>
															</Item>
														</div>]
													);
												});
											}}
										/>
									</Grid>
						</div>

						<div className="Template-map">
							<div className="Map">
								<Entry
									id={this.props.data.locations}
									results={items => {
										//console.log('render Map')
										return (
											<GoogleMap
												markers={items}
												activeMarker={
													this.state.activeMarker
												}
												activeCenter={
													this.state.activeCenter
												}
												filter={entry.locationCategory}
												allRefs={this.refs}
												fitBounds={this.state.mode == 'map' ? 1:0}
											/>
										);
									}}
								/>
							</div>
						</div>
					</div>
				</div>
			</FadeIn>
		);
	}
}

export default withSite(withData(Map));



// WEBPACK FOOTER //
// ./src/js/templates/Map.js